import { Spin } from 'antd';

const Loading = () => {
  return <Spin className="loading-center" size="large" />;
};

export default Loading;
